/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DecisionEnum } from './DecisionEnum';
import {
    DecisionEnumFromJSON,
    DecisionEnumFromJSONTyped,
    DecisionEnumToJSON,
    DecisionEnumToJSONTyped,
} from './DecisionEnum';

/**
 * Serializer to create the decision taken for an unmatched data point.
 * @export
 * @interface UnmatchedDataPointDecisionRequest
 */
export interface UnmatchedDataPointDecisionRequest {
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPointDecisionRequest
     */
    dataPoint: string;
    /**
     * 
     * @type {DecisionEnum}
     * @memberof UnmatchedDataPointDecisionRequest
     */
    decision: DecisionEnum;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPointDecisionRequest
     */
    site?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPointDecisionRequest
     */
    notes?: string;
}



/**
 * Check if a given object implements the UnmatchedDataPointDecisionRequest interface.
 */
export function instanceOfUnmatchedDataPointDecisionRequest(value: object): value is UnmatchedDataPointDecisionRequest {
    if ((!('dataPoint' in (value as Record<string, any>)) && !('data_point' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataPoint'] === undefined && (value as Record<string, any>)['data_point'] === undefined)) return false;
    if (!('decision' in value) || value['decision'] === undefined) return false;
    return true;
}

export function UnmatchedDataPointDecisionRequestFromJSON(json: any): UnmatchedDataPointDecisionRequest {
    return UnmatchedDataPointDecisionRequestFromJSONTyped(json, false);
}

export function UnmatchedDataPointDecisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnmatchedDataPointDecisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dataPoint': json['data_point'],
        'decision': DecisionEnumFromJSON(json['decision']),
        'site': json['site'] === undefined ? undefined : json['site'] === null ? null : json['site'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UnmatchedDataPointDecisionRequestToJSON(json: any): UnmatchedDataPointDecisionRequest {
    return UnmatchedDataPointDecisionRequestToJSONTyped(json, false);
}

export function UnmatchedDataPointDecisionRequestToJSONTyped(value?: UnmatchedDataPointDecisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data_point': value['dataPoint'],
        'decision': DecisionEnumToJSON(value['decision']),
        'site': value['site'],
        'notes': value['notes'],
    };
}

